module.exports = __webpack_public_path__ + "static/media/download.966abc92.jpeg";